module.exports = __webpack_public_path__ + "static/media/logo-horizontal-white.3b9b7258.svg";